// src/components/FormSections/FormSectionDireccion.js

import React from "react"
import { Row, Col } from "reactstrap"
import FormikInput from "../Common/Formik/FormikInput"
import FormikSelect from "../Common/Formik/FormikSelect"

// Opciones para selects (pueden ser importadas desde un archivo separado)
import {
  estadosFederativosOptions,
  paisesOptions,
} from "../../utils/catalogoOptions"

const FormSectionDireccion = ({
  formik,
  resetForm,
  handleUpperCaseChange,
  handleLowerCaseChange,
}) => {
  return (
    <>
      {/* Sección de Dirección */}
      <h5 className="mb-4">Dirección</h5>
      {/* Calle, #Exterior, #Interior, Colonia */}
      <Row>
        <Col md={4}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Calle"
              name="Calle"
              placeholder="Calle"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        <Col md={2}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Numero Exterior"
              name="Numero_Exterior"
              placeholder="Numero Exterior"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        <Col md={2}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Numero Interior"
              name="Numero_Interior"
              placeholder="Numero Interior"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        <Col md={4}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Colonia"
              name="Colonia"
              placeholder="Colonia"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
      </Row>
      {/* Municipio, Ciudad, Estado, Pais */}
      <Row>
        {/* Municipio */}
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Municipio"
              name="Municipio"
              placeholder="Municipio"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>

        {/* Ciudad */}
        <Col md={3}>
          <div className="mb-3">
            <FormikInput
              label="Ciudad"
              name="Poblacion"
              placeholder="Ciudad"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>

        {/* Estado */}
        <Col lg={3}>
          <div className="mb-3">
            <FormikSelect
              label="* Estado Federativo"
              name="id_Estado"
              options={estadosFederativosOptions}
              formik={formik}
              placeholder="Selecciona Estado"
            />
          </div>
        </Col>

        {/* Pais */}
        <Col lg={3}>
          <div className="mb-3">
            <FormikSelect
              label="* País"
              name="id_Pais"
              options={paisesOptions}
              formik={formik}
              placeholder="Selecciona País"
              default
            />
          </div>
        </Col>
      </Row>
      {/* Cp, Apartado Postal, Atención, GPS */}
      <Row>
        {/* Código Postal */}
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Código Postal"
              name="Codigo_Postal"
              placeholder="Código Postal"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        {/* Apartado Postal */}
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Apartado Postal"
              name="Apartado_Postal"
              placeholder="Apartado Postal"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        {/* Atención */}
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Atención"
              name="Atencion"
              placeholder="Atención"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        {/* Gps */}
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Coordenadas GPS"
              name="Coordenadas_GPS"
              placeholder="Coordenadas GPS"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
      </Row>
      {/* Linea Teléfonos */}
      <Row className="mb-2">
        <Col>
          <h5>Teléfonos.</h5>
        </Col>
      </Row>
      {/* Telefono Fijo, Telefono Fijo2, Telefono Fijo 3 */}
      <Row>
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Telefono Fijo"
              name="Telefono_Fijo"
              placeholder="Telefono Fijo"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Telefono Fijo 2"
              name="Telefono_Fijo2"
              placeholder="Telefono Fijo 2"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Telefono Fijo 3"
              name="Telefono_Fijo3"
              placeholder="Telefono Fijo 3"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
      </Row>
      {/* Conmutador, Extensión, Fax */}
      <Row>
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Conmutador"
              name="Conmutador"
              placeholder="Conmutador"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        <Col md={3}>
          {" "}
          <div className="mb-3">
            <FormikInput
              label="Extensión"
              name="Extension"
              placeholder="Extensión"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        <Col lg={3}>
          <div className="mb-3">
            <FormikInput
              label="Fax"
              name="Fax"
              placeholder="Fax"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
      </Row>
    </>
  )
}

export default FormSectionDireccion
